<template lang='pug'>
.articleStory-bottom
  .articleStory-grid
    .articleStory-itemGrid
      span.articleStory-titleGrid 瀏覽人數
      span.articleStory-subtitleGrid {{ getNumberString(viewCount) }}
    .articleStory-itemGrid
      span.articleStory-titleGrid 發布機關
      span.articleStory-subtitleGrid {{ this.$route.query.govOptionName }}

  .articleStory-rightBottom
    .articleStory-social(v-if="identity != 'partners'" )
      .articleStory-itemSocial
        a.articleStory-facebook(:href='"https://www.facebook.com/sharer/sharer.php?u=" + windowLocationHref'
          target="_blank")
      .articleStory-itemSocial
        a.articleStory-line(:href='"https://social-plugins.line.me/lineit/share?url=" + windowLocationHref'
          target="_blank")
    .articleStory-button(v-if='followed' class="articleStory-button--outlined")
      .articleStory-iconButton.icon-following
      .articleStory-textButton {{ staticData.articlePage.linkToArticle }}
    .articleStory-button(v-else @click="goto" class="articleStory-button--blue")
      .articleStory-textButton {{ staticData.articlePage.linkToArticle }}
</template>

<script>
import { getNumberString } from "@/plugins/tool.js"
import { setGtag } from "@/plugins/gtag.js"

export default {
  props: {
    info: Object,
    staticData: Object,
    followStatus: Boolean
  },
  data() {
    return {
      localFollowStatus: null,
      getNumberString: getNumberString,
      token: localStorage.getItem(this.$store.state.storageKeys.token),
      windowLocationHref: "",
      identity: localStorage.getItem(this.$store.state.storageKeys.identity)
    }
  },
  created() {
    this.windowLocationHref = encodeURIComponent(window.location.href)
  },
  computed: {
    followed() {
      return this.localFollowStatus != null ? this.localFollowStatus : this.followStatus
    },
    viewCount(){
      return this.info.viewCount
    }
  },
  methods: {
    goto() {
      const url = this.info.url
      const identity = localStorage.getItem(this.$store.state.storageKeys.identity)
      if (identity === 'users' || identity === null) {
        // eslint-disable-next-line
        setGtag(this.info.content, '公共事務', this.info.content, this.info.id)
      }
      window.open(url, "_blank")
    }
  }
}
</script>
